import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 20px;
  margin-top: 37px;
  margin-left: auto;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 155px;
`
